@if (dailyBonusModalData) {
  <div class="c-dailyBonus">
    <div class="e-dailyBonus__logo"></div>
    <span class="e-dailyBonus__title">{{ 'home.lobby.modals.daily-bonus.message' | translate }}</span>
    <div class="e-dailyBonus__container">
      @for (item of dailyBonusModalData.properties.daysReward; track item; let i = $index) {
        <div
          class="c-dailyBox"
          [ngClass]="{
            'c-dailyBox--disableNext': i + 1 > dailyBonusModalData.properties.visitStreak,
            'c-dailyBox--disablePrevious': i + 1 < dailyBonusModalData.properties.visitStreak
          }">
          <div class="c-dailyBox__day">{{ 'home.lobby.modals.daily-bonus.day' | translate }} {{ i + 1 }}</div>
          <div class="c-dailyBox__image c-dailyBox__image--{{ i + 1 }}">
            <div class="c-dailyBox__image--check"></div>
          </div>
          <slotcom-display [classes]="['c-display--dailyBonus']">
            <div
              displayIcon
              displayIconPos="left"
              class="c-display--coin"></div>
            {{ item.credits | beautifyNumber: ('common.culture' | translate) }}
          </slotcom-display>
          @if (i + 1 === dailyBonusModalData.properties.visitStreak) {
            <div class="c-dailyBox__redeem">
              <slotcom-button
                data-testid="slotcom-lobby-dailyBonus-button"
                class="c-button--dailyBonus"
                (safeClick)="closeModal()"
                audioType="reward">
                {{ 'common.collect' | translate | uppercase }}
              </slotcom-button>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
